export const getForgotPasswordState = state => state.forgotPassword;
export const getResetPasswordEmailSent = state => getForgotPasswordState(state).resetEmailSent;
